import { createFileRoute } from "@tanstack/react-router";

import { PraxaHistoryThread } from "../components/praxa/PraxaHistorySurface";

export const Route = createFileRoute("/w/$workspaceId/conversations/$conversationId")({
  component: PraxaConversationHistoryRoute,
});

function PraxaConversationHistoryRoute() {
  const { workspaceId, conversationId } = Route.useParams();
  return (
    <PraxaHistoryThread
      selection={{ kind: "conversation", conversationId }}
      workspaceId={workspaceId}
    />
  );
}
